import { Strategy, StrategyAllocation } from '@ndvr/portfolio-api';

import { formatWeightForDisplay } from '../../../shared-utils';
import { FormValues } from '../EditAllocationDialog';

/**
 * Get default form values from allocation data
 * Allocation-specific: handles allocationGroupName and allocationType
 */
export function getDefaultFormValues(allocationData?: any): FormValues {
    return {
        allocationName: allocationData?.allocationName || '',
        allocationGroupName: allocationData?.allocationGroupName || '',
        allocationType: allocationData?.allocationType || ('PERSONAL' as any),
        strategyAllocations: allocationData?.strategyAllocations
            ? allocationData.strategyAllocations
                  .map((strategy: StrategyAllocation) => ({
                      ...strategy,
                      weight: formatWeightForDisplay(strategy.weight),
                  }))
                  .sort((a: any, b: any) => parseFloat(b.weight) - parseFloat(a.weight))
            : [],
    };
}

/**
 * Find a strategy by its GUID
 * Allocation-specific: used to look up strategies in allocation context
 */
export function getStrategyByGUID(strategies: Strategy[], guid: string): Strategy | undefined {
    return strategies.find((s) => s.strategyGUID === guid);
}
